export default {
  legalTerms: 'https://influence.kolsquare.com/pages/fr-cgu-0325/',
  privacyPolicy: 'https://influence.kolsquare.com/pages/fr-confidentialite-0325',
};
